import React, {useState, useEffect} from 'react';
import {Line} from 'react-chartjs-2';
import { chartBlue } from '../../common/theme';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import {toTime, toTimeType, timeConverter, isObjectEmpty, uploadCSV, replaceAll, toArray, timeConverterSM} from '../../../Utils';
import Spinner from '../../common/generic/Spinner';

const ContainerComp = ({pageState, reportState, csvData, setcsvData}) =>{
    const {database, deleteThis, request, fetchModules, modulesData, modulesReady } = pageState;
    const [processedMarks, setProcessedMarks] = useState({});
    const [processedGraphs, setProcessedGraphs] = useState({});
    const [markRecords, setMarkRecords] = useState({});
    const {selectedStudents, selectedProgram} = reportState;
    const [markPosttestRecords, setMarkPostestRecords] = useState({});

    /*
    CSV NOTES
    =========
    There is a big problem when trying to upload more then 1 csv file.  The below system will reset all the data in 
    this component and start it over when when the user clicks save.
    
    Steps
    1) User clicks save in either ProgramReportTableComp or AcitivityReportComp
        1b) openCSVPage() will populate csvData using setcsvData({processStage:'newRequest'});
    2) ViewReportsPage checks to see if the marks have changed (* seems to be called way to many times...)
        2b) setReportType(csvData.reportType);
            setSelectedProgram({...csvData.selectedProgram});
            setSelectedStudents([...csvData.selectedStudents]); 
    3) Start the report
        3a) CSV Step 1: checks if a new request for csv and starts to clear the data
        3b) CSV Step 2: clears the data 
        3c) CSV Step 3: keep checking to see when the data has been cleared
        3d) CSV Step 4: once the data for this component has been reset then start the normal start up process for this comp.
        3e) (The normal Startup starts at CSV Step 1) 
    */

    // CSV Step 4: once the data for this component has been reset then start the normal start up process for this comp.
    // The normal Startup starts at CSV Step 1 
    const tryLoadingCSVStage2 = () => {
        if(!csvData) return;
        if(csvData.processStage === 'clearingData'){
            if(!database['getPretestModuleMarks'] && !database['getPosttestModuleMarks'] && isObjectEmpty(markRecords) && isObjectEmpty(processedMarks)){
                setcsvData({...csvData, processStage:'clearedData'});
            }
        }
    };
    // CSV Step 3: keep checking to see when the data has been cleared
    useEffect(() =>{tryLoadingCSVStage2();},[database['getPretestModuleMarks']]);
    useEffect(() =>{tryLoadingCSVStage2();},[database['getPosttestModuleMarks']]);
    useEffect(() =>{tryLoadingCSVStage2();},[markRecords]);
    useEffect(() =>{tryLoadingCSVStage2();},[processedMarks]);

    // CSV Step 2: clears the data
    useEffect(() => {
        if(!csvData) return;

        if(csvData.processStage === 'clearingData'){
            deleteThis('getPretestModuleMarks');
            deleteThis('getPosttestModuleMarks');
            setMarkRecords({});
            setProcessedMarks({});
        }
    },[csvData]);

    // CSV Step 1: checks if a new request for csv and starts to clear the data 
    // Normal Startup Step 1:
    useEffect(() => {
        if(csvData){
            if(csvData.processStage==='newRequest'){
                // csvData.setloadingCSV({...csvData.loadingCSV, posttest:true});
                setcsvData({...csvData, processStage:'clearingData'});
                return;
            }

            if(csvData.processStage==='clearingData') return;
        }

        if(!isObjectEmpty(markRecords)) return; // already loading

        if(!database['getPretestModuleMarks']){
            let studentQueries = [];
            selectedStudents.forEach(studentRec=>{
                let getAllPostTestQuery={
                    params: studentRec.id+'~'+selectedProgram.name,
                    func:'getPosttestModuleMarks',           
                };
                let getMarksQuery={
                    params: studentRec.id+'~'+selectedProgram.name,
                    func:'getPretestModuleMarks'          
                };
                studentQueries.push(getAllPostTestQuery);
                studentQueries.push(getMarksQuery);
                return getMarksQuery;
            });

            if(studentQueries.length > 0){
                let counter = 1;
                studentQueries = studentQueries.map((query,i)=>{
                    let prevQuery = (i!=0) ? studentQueries[i-1] : 'undefinded';
                    if(prevQuery !== 'undefinded'){
                        counter++;
                        query.nextRequest = prevQuery;
                    }
                    return query;
                });
                let loadChainedMarks = studentQueries[studentQueries.length-1];
                loadChainedMarks.numQueries = counter;
                setMarkRecords({info:{numStudents:counter,numLoaded:counter}});

                // pass the link list of saved changes into the database
                request(loadChainedMarks); 
            }
            else
                console.log('Nothing to load?');
        }
    });

    // convert database['getPretestModuleMarks'] into setMarkRecords
    // UDATES - when database['getPretestModuleMarks'] changes
    useEffect(() => {
        if(csvData && csvData.processStage !== 'clearedData') return; // don't setup markRecords for csv files without being ready 
        if(isObjectEmpty(markRecords)) return;
        (!pageState.isFetchingModules && !modulesReady) && fetchModules(selectedProgram.id.toLowerCase());
        if(!database['getPretestModuleMarks']) return;
        
        let marks = {};
        let key = 'unavailable';
        let counter = {...markRecords.info};

        if(database['getPretestModuleMarks'].isLoaded) counter.numLoaded--;
        
        marks = {
            isloaded: database['getPretestModuleMarks'].isLoaded,
            data: database['getPretestModuleMarks'].data
        }; 

        if((marks.data) && !isObjectEmpty(marks.data)){
            key = Object.keys(marks.data)[0].split('+')[0];
        }

        setMarkRecords({...markRecords, info:{...counter}, [key]:marks});

    }, [database['getPretestModuleMarks']]); 

    useEffect(() => {

        (!pageState.isFetchingModules && !modulesReady) && fetchModules(selectedProgram.id.toLowerCase());
        if(!database['getPosttestModuleMarks']) return;
        if(isObjectEmpty(markRecords)) return;
        
        let marks = {};
        let key = 'unavailable';
        let counter = markRecords.info;

        if(database['getPosttestModuleMarks'].isLoaded) counter.numLoaded--;
        
        marks = {
            isloaded: database['getPosttestModuleMarks'].isLoaded,
            data: database['getPosttestModuleMarks'].data
        }; 

        if((marks.data) && !isObjectEmpty(marks.data)){
            key = Object.keys(marks.data)[0].split('+')[0];
        }

        setMarkPostestRecords({...markPosttestRecords,[key]:marks});
        setMarkRecords({...markRecords, info:{...counter}});
    }, [database['getPosttestModuleMarks']]); 

    let hasSavedCSV = false;
    const tryLoadingNow = () => {
        if(isObjectEmpty(markRecords)) return;
        if(isObjectEmpty(markPosttestRecords)) return;
        if(!isObjectEmpty(processedMarks)) return;
        if(hasSavedCSV) return;
        if(markRecords.info.numStudents > 0 && markRecords.info.numLoaded > 0) return;

        if(modulesReady) {
            hasSavedCSV = true; 

            let posttestDatesByStudents = selectedStudents.reduce((accOutter,studentRec)=>{
                let studentID = studentRec.id;
                if(!markPosttestRecords[studentID]) return accOutter;
    
                let posttestDates = toArray(markPosttestRecords[studentID].data).reduce( (accInner, postRec) => {
                    if(!accInner.includes(postRec.TimeIssued))
                        accInner.push(postRec.TimeIssued);
                    return accInner;
                },[]);
                
                accOutter[studentID] = posttestDates.sort((a, b) => a - b); 
                return accOutter;
            },{});

            let studentsModuleGraphs = selectedStudents.reduce((accStud,studentRec)=>{
                let studentID = studentRec.id;
                let studentMarkRecords = markRecords[studentID];
                let posttestDates = posttestDatesByStudents[studentID];
                if(!posttestDates) return accStud; // still loading marks

                let marksPerModule = modulesData.map(moduleRec => { 
                    let moduleID = moduleRec.moduleID;
                    let data = [];
                    let titles = ['Pretest'];
                    if(studentMarkRecords && studentMarkRecords.data[`${studentID}+${selectedProgram.name}+${moduleID[0]}`]) {
                        let dataPoint = studentMarkRecords.data[`${studentID}+${selectedProgram.name}+${moduleID[0]}`];
                        let mark = Math.round((dataPoint.QuestionsRight/dataPoint.QuestionsTotal)*100);
                        data.push (mark);
                    }
                    else{
                        data.push (0);
                    }
                    posttestDates.forEach(postDate=>{
                        if(markPosttestRecords[studentID].data[`${studentID}+${selectedProgram.name}+${moduleID[0]}+${postDate}`]) {
                            let dataPoint = markPosttestRecords[studentID].data[`${studentID}+${selectedProgram.name}+${moduleID[0]}+${postDate}`];
                            let mark = Math.round((dataPoint.QuestionsRight/dataPoint.QuestionsTotal)*100);    
                            data.push (mark);
                            titles.push(timeConverter(parseInt(postDate)));
                        }    
                    });                    

                    return {moduleName:moduleID[1],titles,data};
                });

                accStud[`${studentRec.id}+${studentRec.name}`] = marksPerModule;
                return accStud;
            },{}); 
            
            setProcessedGraphs(studentsModuleGraphs);

            let studentsModuleMarks = selectedStudents.reduce((accStud,studentRec)=>{
                let studentID = studentRec.id;
                let studentMarkRecords = markRecords[studentID];
                // if(!studentMarkRecords) return accStud; // still loading marks <==== Might be required but breaks letting you see the report with pretests
                let posttestDates = posttestDatesByStudents[studentID];
                if(!posttestDates) return accStud; // still loading marks

                let marksPerModule = modulesData.reduce((acc, moduleRec) => { 
                    let moduleID = moduleRec.moduleID;
                    if(studentMarkRecords && studentMarkRecords.data[`${studentID}+${selectedProgram.name}+${moduleID[0]}`]) {
                        acc.push ({moduleID, mark: studentMarkRecords.data[`${studentID}+${selectedProgram.name}+${moduleID[0]}`]});
                    }
                    else{
                        acc.push ({moduleID, mark: {QuestionsRight:0, QuestionsTotal:0, Duration:0} });
                    }
                    posttestDates.forEach(postDate=>{
                        if(markPosttestRecords[studentID].data[`${studentID}+${selectedProgram.name}+${moduleID[0]}+${postDate}`]) {
                            acc.push ({moduleID, date: timeConverter(parseInt(postDate)), mark: markPosttestRecords[studentID].data[`${studentID}+${selectedProgram.name}+${moduleID[0]}+${postDate}`]});
                        }    
                    });
                    
                    return acc;
                },[]);

                accStud[`${studentRec.id}+${studentRec.name}`] = marksPerModule;
                return accStud;
            },{});
            setProcessedMarks(studentsModuleMarks);

            if(csvData){
                let newLine = '%0A';
                let csvString = '';
                csvString =`"If the student has a grade less then 80%, that module will be assigned to them. "${newLine}`;
                csvString +=`"Students without marks will not appear in this report"${newLine}`;
                let tableHeaderStr = '"Modules Tested","Questions Correct","Num of Questions","Score","Time","Assigned to Student"'+newLine;

                Object.keys(studentsModuleMarks).forEach((key) => { 
                    let headerStr = `${newLine}"${key.split('+')[1]}"${newLine}"${selectedProgram.name}"${newLine}"Post Test Report"${newLine}`;
                    let tableData  = studentsModuleMarks[key];

                    csvString += headerStr + tableHeaderStr;
                    tableData.forEach((moduleRec) => {
                        const { moduleID, mark, date} = moduleRec;
                        const { QuestionsRight, QuestionsTotal, Duration} = mark;
                        const score = Math.round((QuestionsRight/QuestionsTotal)*100);

                        let recordStr = '';
                        if(!date)
                            recordStr += `"${moduleID[1]}"${newLine}`;
                        recordStr += `"${(date)?date.trim():'Pretest'}","${QuestionsRight}","${QuestionsTotal}","${(isNaN(score)?'--':score)}%","${toTime(Duration)} ${toTimeType(Duration)}","${(date)?'--':((QuestionsRight/QuestionsTotal) >= 0.8)? 'No' : 'Yes'}"${newLine}`;
                        csvString += recordStr;
                    });

                    let footer = '"If the student has a grade less then 80%, that module will be assigned to them."';
                    csvString += footer;
                });
                                
                let name = '';
                if(Object.keys(studentsModuleMarks).length===0){
                    window.alert('There are no marks for the student(s) selected');
                    csvData.setloadingCSV({...csvData.loadingCSV, posttest:false});
                    return;
                }
                if(Object.keys(studentsModuleMarks).length==1)
                    name = Object.keys(studentsModuleMarks)[0].split('+')[1]+'_';

                let today = new Date();
                today = timeConverterSM(today.getTime());

                uploadCSV(name+'PostTestReport_'+selectedProgram.name+'_'+today,csvString);
                //uploadCSV('posttestReport',csvString);
                csvData.setloadingCSV({...csvData.loadingCSV, posttest:false});
            }
        };
    }; 

    useEffect(() =>{tryLoadingNow();},[markPosttestRecords]);
    useEffect(() =>{tryLoadingNow();},[modulesData]);
    useEffect(() =>{tryLoadingNow();},[markRecords]);

    if(csvData) return <></>;
    if(isObjectEmpty(markRecords)) return <> <Spinner/> <center>Loading... ({database['queryCount']})</center> </>;
    if(markRecords.info.numStudents > 0 && markRecords.info.numLoaded > 0) return <> <Spinner/> <center>Loading... ({database['queryCount']})</center> </>;

    return <>
        {Object.keys(processedMarks).length < selectedStudents.length && <center> <p>  Students without marks will not appear in this report </p></center>}
        {Object.keys(processedGraphs).map((key, i) => (
            <span key={i}><br/> 
            <PostTestReportComp header={{student: key.split('+')[1], program: selectedProgram.name}} tableData={processedGraphs[key]}/>            
            <br/></span>
        ))}
    </>;
};

const PostTestReportComp = ({header, tableData}) => {

    const headerComp = <center>
        <h4><Row>
            <Col xs='4'>{header.student}</Col> 
            <Col xs='4'>{header.program} </Col>
            <Col xs='4'>Post Test Report</Col>
        </Row></h4>
    </center>;
    
    const footer = <center>
       <hr/> If the student has a grade less then 80%, that module will be assigned to them. 
    </center>;

    return (
        <> 
            {headerComp}
            <hr/>
            {tableData.map((moduleRec, module_i) =>
                 <span key={module_i}>               
                    <TableRow key={module_i} data={moduleRec} fontWeight={'normal'}/>
                </span>
            )} 
            {footer}
        </>
    );
};
PostTestReportComp.propTypes = {
    tableData: PropTypes.array
};

const TableRow = (props) => {
    const { moduleName, titles, data} = props.data;

    return (<>

    <Row style={{fontSize:'0.9em'}}>
        <Col xs='12' ><h4>{moduleName}</h4></Col>

        <Col xs='12' style={{ height: 100 }}>
            <Line
                data={
                    {
                        labels: titles,
                        datasets:[
                            {
                                label: 'marks',
                                backgroundColor: '#FF0000',
                                data,
                                fill: false
                            }
                        ]
                    }
                }
                options= {{
                    maintainAspectRatio: false,
                    legend:{
                        display:false
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                min: 0,
                                max: 100
                            }
                        }]
                    }                    
                }}
            />
        </Col>
    </Row>
    <br/>
    </>);
};

TableRow.propTypes = {
    fontWeight: PropTypes.string,
    data: PropTypes.object
};

export default ContainerComp;